// Runtime config resolved from the iframe URL (the loader forwards these), with
// build-time env fallbacks so the widget also runs standalone in dev.

const params = new URLSearchParams(
  typeof window !== "undefined" ? window.location.search : "",
);

const decode = (key: string, fallback: string): string => {
  const raw = params.get(key);
  return raw ? decodeURIComponent(raw) : fallback;
};

const ownHref = typeof window !== "undefined" ? window.location.href : "";

const originFrom = (href: string): string => {
  try {
    return new URL(href).origin;
  } catch {
    return "*";
  }
};

export interface IWidgetConfig {
  /** Proxy backend base URL the widget POSTs leads to. */
  beUrl: string;
  /** Public vendor key presented to the proxy (identifies the embedder/tenant). */
  vendorKey: string;
  /** Origin to target postMessage at (derived from the host page URL). */
  parentOrigin: string;
  /** Optional pre-approved direct-mail URL for the secondary CTA. */
  directMailUrl: string;
}

export const widgetConfig: IWidgetConfig = {
  beUrl: params.get("beUrl") || import.meta.env.VITE_BE_URL || "",
  vendorKey: params.get("vendorKey") || import.meta.env.VITE_VENDOR_KEY || "",
  parentOrigin: originFrom(decode("__origin", ownHref)),
  directMailUrl:
    params.get("directMailUrl") || import.meta.env.VITE_DIRECT_MAIL_URL || "",
};
